<template>
  <v-card class="ma-2">
    <v-card-title>{{formType == "sat" ? "CONTACTE CON EL SERVICIO TÉCNICO" : "CONTACTE CON LOGÍSTICA"}}</v-card-title>
    <v-card-text v-if="formType == 'sat'">
      El siguiente formulario es necesario para hacernos conocedores de todos los datos referentes a su solicitud para
      poder ofrecerle el mejor servicio.
    </v-card-text>
    <v-card-text v-if="formType == 'logistics'">
      El siguiente formulario es necesario para hacernos conocedores de todos los datos referentes a su incidencia de transporte.
      <br/><b>Recuerde que sólo tenemos 24 horas desde la recepción del envío para reclamar su incidencia al seguro. Es imprescindible que usted haya anotado 
      la incidencia en el albarán de entrega o PDA del tranportista.</b>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Header",
  props: ["formType"]
}
</script>

<style scoped>

</style>